import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editFindingCategoryDialog from '../dialog.editFindingCategoryDialog';
import editFindingDialog from '../dialog.editFindingDialog';
import controller from './finding-category.controller';
import directive from './finding-category.directive';
import finding from '../finding';


export default angular.module('app.components.advisory.auditTrail.findingCategory', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  editFindingCategoryDialog,
  editFindingDialog,
  finding,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amFindingCategory', directive)
  .controller('FindingCategoryController', controller)
  .name;

console.log('app.components.advisory.auditTrail.findingCategory created');
